// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import {credits, site} from '../src/api/user'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    theme: {
      color1: '#ffffff',
      color2: '#ffffff',
      color3: '#ffffff',
      color4: '#ffffff',
    },
    points: 0,
    site_title: '',

  },
  mutations: {
    updateTheme(state, payload) {
      // 这里使用 Object.assign 来确保我们不是在修改原始对象
      Object.assign(state.theme, payload);
    },
    // 更新积分的方法
    UPDATE_POINTS(state, newPoints) {
      state.points = newPoints
    },
    // 全局oem名字
    UPDATE_TITLE(state, newTitle) {
      state.site_title = newTitle
    },
  },
  actions: {
    updateTheme({ commit }, payload) {
      // 假设这里我们进行了一些异步操作，比如 API 请求
      // 然后我们提交一个 mutation 来更新状态
      commit('updateTheme', payload);
    },
    // 异步更新积分的方法
    async updatePoints({ commit }) {
      try {
        const response = await this.dispatch('getCredits')
        commit('UPDATE_POINTS', response)
        return response.data
      } catch (error) {
        console.error('获取积分失败:', error)
        throw error
      }
    },
    async getCredits() {
      try {
        const res = await credits()
        return res.data.credits ? res.data.credits : 0
      } catch (error) {
        console.error('获取积分失败:', error)
        return 0
      }
    },

    // 获取OEM信息
    async getOemInfo({ commit }) {
      try {
        const response = await this.dispatch('getSite')
        commit('UPDATE_TITLE', response)
        // return response.data
      } catch (error) {
        console.error('获取积分失败:', error)
        throw error
      }
    },
    async getSite() {
      try {
        const res = await site()
        return res.data.site_title ? res.data.site_title : '超级分身'
      } catch (error) {
        console.error('获取积分失败:', error)
        return 0
      }
    },


  },
  getters: {
    getTheme: state => state.theme,
    getPoints: state => state.points,
    getTitle: state => state.site_title,
  }
});



//////////////////
// WEBPACK FOOTER
// ./utils/store.js
// module id = null
// module chunks = 